import type { AssistantUsagesListRow } from "@/admin/entities/assistant";
import type { AssistantUsagesListQueryType } from "@/types/graphql/admin.generated";

export function getTableData(data: unknown): {
  nodes: AssistantUsagesListRow[];
  count: number;
} {
  const usages = (data as AssistantUsagesListQueryType)?.assistantUsages;
  if (!usages || !usages.nodes) {
    return { nodes: [], count: 0 };
  }
  return usages;
}

export function mapColumns(row: AssistantUsagesListRow) {
  return [
    row.id,
    row.audience,
    row,
    row,
    row.month,
    row.messages,
    row.costUsd,
    row.budgetUsd,
    row,
  ];
}
